module.exports = __webpack_public_path__ + "img/javascript.f7a3e778.png";